import * as Sentry from '@sentry/react';
import { BackendSocket } from '../../hooks/use-socket';
import { meta } from '../../stores/backend';
import { getQuery } from '../../lib/query';

export const onDisconnect = (socket: BackendSocket, _context: unknown) => {
    const callback = async () => {
        const { USERID: userId } = getQuery();
        // Default to false (manual reload required) unless explicitly set to 'true'
        const autoReconnect =
            import.meta.env.REACT_APP_WS_AUTO_RECONNECT === 'true';

        // Log to Sentry
        Sentry.captureMessage('Socket disconnected', {
            level: 'info',
            tags: {
                socketType: 'backend',
                userId: userId || 'unknown',
            },
        });

        // Show the appropriate modal based on the auto-reconnect setting
        meta.modals.msgCommon.set({
            name: autoReconnect
                ? 'error.socketConnectionInterruptedWait'
                : 'error.socketConnectionInterrupted',
            isOpen: true,
            closeBehavior: autoReconnect ? 'close' : 'reload',
            showButton: !autoReconnect,
            buttonText: !autoReconnect ? 'messageModal.reload' : undefined,
            buttonBehavior: !autoReconnect ? 'reload' : undefined,
        });
    };

    socket.on('disconnect', callback);

    return () => {
        socket.off('disconnect', callback);
    };
};
